interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  accent?: "primary" | "accent" | "secondary";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  accent = "primary",
}: SectionHeadingProps) {
  const dot = {
    primary: "bg-primary-500",
    accent: "bg-accent-500",
    secondary: "bg-secondary-500",
  }[accent];

  const text = {
    primary: "text-primary-600",
    accent: "text-accent-600",
    secondary: "text-secondary-700",
  }[accent];

  return (
    <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className={`flex items-center gap-2 text-xs font-semibold tracking-[0.2em] ${text}`}>
          <span className={`h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden="true" />
          {eyebrow}
        </p>
        <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
    </div>
  );
}